/* gelmanicurepen.com — global: cart drawer (Cart AJAX API + Section Rendering API), accordion fallback. No dependencies. */
(() => {
  const R = (window.GMP && window.GMP.routes) || { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', root: '/' };
  const SECTION = 'cart-drawer';
  const drawer = document.querySelector('[data-cart-drawer]');
  const panel = drawer && drawer.querySelector('.gmp-drawer__panel');
  let lastFocus = null;

  /* ---------- open / close ---------- */
  function open() {
    if (!drawer) { window.location.href = R.cart; return; }
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.classList.add('is-entering');
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.remove('is-entering')));
    document.body.classList.add('gmp-lock');
    panel.focus();
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('gmp-lock');
    const back = lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : document.querySelector('.gmp-bag');
    if (back && back.focus) back.focus();
  }

  if (drawer) {
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- cart requests ---------- */
  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTION, sections_url: window.location.pathname }, body))
    });
    let data = {};
    try { data = await res.json(); } catch (e) { /* non-JSON error page */ }
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sorry, something went wrong. Please try again.');
    return data;
  }
  const add = (items) => post(R.cartAdd, { items });
  const change = (key, quantity) => post(R.cartChange, { id: key, quantity });

  async function fetchSection() {
    const res = await fetch(`${R.root.replace(/\/$/, '')}/?sections=${SECTION}`);
    const json = await res.json();
    return json[SECTION];
  }

  /* Swap only the dynamic parts, so Shopify's express checkout buttons in the footer are never re-mounted. */
  async function render(data) {
    let html = data && data.sections && data.sections[SECTION];
    if (!html) html = await fetchSection();
    if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const swap = (sel) => {
      const a = drawer.querySelector(sel), b = doc.querySelector(sel);
      if (a && b) a.innerHTML = b.innerHTML;
    };
    swap('[data-drawer-body]');
    swap('[data-drawer-totals]');
    const newFoot = doc.querySelector('[data-drawer-foot]');
    const foot = drawer.querySelector('[data-drawer-foot]');
    const empty = newFoot && newFoot.hasAttribute('data-empty');
    if (foot) foot.toggleAttribute('data-empty', !!empty);
    const btn = drawer.querySelector('[data-drawer-checkout]');
    if (btn) btn.disabled = !!empty;
    const count = (doc.querySelector('[data-cart-count]') || {}).textContent;
    if (count != null) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count.trim();
        if (el.hasAttribute('aria-label')) el.setAttribute('aria-label', `${count.trim()} items in bag`);
      });
    }
    document.dispatchEvent(new CustomEvent('gmp:cart-updated'));
  }

  function showError(err) {
    const el = drawer && drawer.querySelector('[data-cart-error]');
    if (!el) { window.alert(err.message); return; }
    el.textContent = err.message;
    el.hidden = false;
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      rm.disabled = true;
      change(rm.getAttribute('data-cart-remove'), 0).then(render).catch(showError);
      return;
    }
    const up = e.target.closest('[data-cart-add]');
    if (up) {
      up.disabled = true;
      add([{ id: Number(up.getAttribute('data-cart-add')), quantity: 1 }])
        .then(render)
        .catch((err) => { up.disabled = false; showError(err); });
    }
  });

  // Returning via the back button can show a stale cached page: refresh the bag.
  window.addEventListener('pageshow', (e) => { if (e.persisted) render(null); });

  window.GMPCart = { open, close, add, change, render };

  /* ---------- mobile menu (burger) ---------- */
  const header = document.querySelector('[data-header]');
  const burger = header && header.querySelector('[data-menu-toggle]');
  if (burger) {
    const setMenu = (open) => {
      header.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    };
    burger.addEventListener('click', () => setMenu(!header.classList.contains('is-open')));
    header.querySelectorAll('.gmp-nav a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && header.classList.contains('is-open')) { setMenu(false); burger.focus(); } });
    document.addEventListener('click', (e) => { if (header.classList.contains('is-open') && !header.contains(e.target)) setMenu(false); });
  }

  /* ---------- exclusive accordions: <details name="..."> fallback for older browsers ---------- */
  if (!('name' in HTMLDetailsElement.prototype)) {
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open) return;
      const n = d.getAttribute('name');
      if (!n) return;
      document.querySelectorAll(`details[name="${CSS.escape(n)}"]`).forEach((o) => { if (o !== d) o.open = false; });
    }, true);
  }
})();
